const AGGREGATE_RATING = `"aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "173",
    "reviewCount": "173",
    "bestRating": "5",
    "worstRating": "1"
  },`;
const REVIEW = `"review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Kenneth Jensen"
      },
      "description": "Jeg fikk hjelp med en gang jeg sparte ca 70 tusen . Kan anbefales",
      "datePublished": ""
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Frank Kragh Eckell"
      },
      "description": "Bra sted til en brøkdel av det du betaler andre steder"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ingar Berre"
      },
      "description": "Skriv inn info om lønn og lån. Få tilbud på refinansiering av gjeld og velg den billigste avtalen. Enkelt og greit."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Petter Nielsen"
      },
      "description": "Veldig effektivt, 100% profesjonelt, kvalitet hele veien, kunden føler \\"her blir man tatt vare på.\\" Det blir man 100%."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Mona Strand"
      },
      "description": "Veldig hyggelig og hjelpsom kundebehandler hos Scoopr. Spart mye på denne hjelpen 😊"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Eivind Saevdal"
      },
      "description": "Rask og god service. Eg sparte masse penger på å bruke Scoopr"
    }
  ],`;
const ADDRESS = `"address": {
    "@type": "PostalAddress",
    "streetAddress": "Karenslyst Allé 2",
    "addressLocality": "Oslo",
    "postalCode": "0278",
    "addressCountry": "NO"
  },`;

function CreateProductRRS({ name, price, image, url, description }) {
  return `{
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "${name}",
  "image": "${image}",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "NOK",
    "price": "${price}",
    "availability": "https://schema.org/InStock",
    "url": "${url}",
    "priceValidUntil": "2023-12-31T23:00:00.000Z"
  },
  ${AGGREGATE_RATING}
  ${REVIEW}
  "description": "${description}",
  "brand": "",
  "sku": "${name}"
}`;
}

function CreateLocalBusinessRRS({ name, image, url, description }) {
  return `{
  "@context": "https://schema.org/",
  "@type": "LocalBusiness",
  "name": "${name}",
  "url": "${url}",
  "image": "${image}",
  "description": "${description}",
  ${ADDRESS}
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "59.91870347961197",
    "longitude": "10.685843646567944"
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday"
      ],
      "opens": "08:00",
      "closes": "20:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Friday",
      "opens": "08:00",
      "closes": "17:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Saturday",
      "opens": "10:00",
      "closes": "14:00"
    },
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": "Sunday",
      "opens": "12:00",
      "closes": "16:00"
    }
  ],
  ${AGGREGATE_RATING}
  ${REVIEW}
  "telephone": "+47 488 46 665"
}`;
}

function CreateArticleRRS({
  headline,
  image,
  url,
  description,
  datePublished,
  dateModified,
}) {
  return `{
    "@context": "https://schema.org/",
    "@type": "Article",
    "headline": "${headline}",
    "url": "${url}",
    "image": "${image}",
    "datePublished": "${datePublished}",
    "dateModified": "${dateModified}",
    "author": {
      "@type": "Organization",
      "name": "Scoopr",
      ${ADDRESS}
      "logo": {
        "@type": "ImageObject",
        "url": "TODO"
      }
    },
    "publisher": {
      "@type": "Organization",
      "name": "Scoopr",
      ${ADDRESS}
      ${AGGREGATE_RATING}
      ${REVIEW}
      "logo": {
        "@type": "ImageObject",
        "url": "TODO"
      }
    },
    "description": "${description}"
  }`;
}

export { CreateArticleRRS, CreateLocalBusinessRRS, CreateProductRRS };
